<app-card [title]="'Foto de Perfil'" [showMinimize]="false" cardClass="mb-0">
  <div class="profile-cropper-body">
    <p class="profile-cropper-hint">
      <i class="fa fa-info-circle"></i>
      Ajuste o recorte desejado e clique em <strong>Salvar</strong>.
    </p>
    <image-cropper #cropper *ngIf="image" [imageBase64]="image" [autoCrop]="false" [format]="imageType"
      [maintainAspectRatio]="true" [aspectRatio]="1" [transform]="cropperTransform" (imageLoaded)="imageLoaded()"
      style="max-height: 50vh;">
    </image-cropper>
    <div class="profile-cropper-actions">
      <button type="button" class="btn btn-primary" (click)="onSave()" [disabled]="saving">
        <i class="fa fa-circle-notch fa-spin" *ngIf="saving"></i>
        <i class="ti ti-save" *ngIf="!saving"></i>
        {{ saving ? 'Salvando...' : 'Salvar' }}
      </button>
      <button type="button" class="btn btn-danger" (click)="onCancel()" [disabled]="saving">
        <i class="ti ti-close"></i> Cancelar
      </button>
    </div>
  </div>
</app-card>